<template>
  <div class="supervision-mg">
    <nuxt-link
      v-if="espacioSupervisado"
      :to="{ name: 'supervision-mg' }"
      class="supervision-mg__aviso"
      title="Abrir el panel de supervisión"
    >
      <i class="iconoir-eye-empty supervision-mg__ojo"></i>
      <span>
        Supervisando <b>«{{ espacioSupervisado.name }}»</b> · no sales en sus
        miembros
      </span>
    </nuxt-link>
    <ConfirmacionSupervision />
  </div>
</template>

<script>
import ConfirmacionSupervision from '@extras_mg/components/ConfirmacionSupervision'
import { cargar, supervision } from '@extras_mg/supervision'

/**
 * Lo que la supervision pone en el layout de la app (getAppLayoutComponent del
 * core: se monta una vez en todas las paginas con sesion).
 *
 *   * Un aviso abajo a la izquierda cuando el espacio abierto es uno que
 *     supervisas, para que nunca se te olvide que estas "de visita".
 *   * El modal de confirmacion de cambios de miembros y roles.
 *
 * A quien no supervisa no se le pinta nada. El modal se monta siempre: solo se
 * abre si el servidor pide confirmar, y si no estuviera montado la peticion se
 * quedaria esperando una respuesta que nunca llega.
 */
export default {
  name: 'SupervisionMG',
  components: { ConfirmacionSupervision },
  computed: {
    soy() {
      return supervision.soy
    },
    usuario() {
      return this.$store.getters['auth/getUserId']
    },
    espacioSupervisado() {
      if (!this.soy) {
        return null
      }
      const espacio = this.$store.getters['workspace/getSelected']
      return espacio && espacio.mg_supervision ? espacio : null
    },
  },
  watch: {
    usuario(id) {
      cargar(this.$client, id)
    },
  },
  mounted() {
    cargar(this.$client, this.usuario)
  },
}
</script>

<style lang="scss">
.supervision-mg__aviso {
  position: fixed;
  left: 50%;
  bottom: 14px;
  transform: translateX(-50%);
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  color: var(--mg-texto, #323338);
  text-decoration: none;
  background: var(--mg-fondo, #ffffff);
  border: 1px solid var(--mg-borde, #d0d4e4);
  box-shadow: 0 2px 10px color-mix(in srgb, currentColor 14%, transparent);
  opacity: 0.92;
}

.supervision-mg__aviso:hover {
  opacity: 1;
  text-decoration: none;
}

.supervision-mg__ojo {
  font-size: 15px;
}
</style>
